import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21l0 -18","key":"svg-0"}],["path",{"d":"M15 6l-3 -3l-3 3","key":"svg-1"}],["path",{"d":"M9 21l6 0","key":"svg-2"}]]

/**
 * IconArrowUpBar
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctdXAtYmFyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiAyMWwwIC0xOCIgLz4KICA8cGF0aCBkPSJNMTUgNmwtMyAtM2wtMyAzIiAvPgogIDxwYXRoIGQ9Ik05IDIxbDYgMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-up-bar
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowUpBar = createReactComponent('outline', 'arrow-up-bar', 'ArrowUpBar', __iconNode);

export default IconArrowUpBar;